import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { _IDIncomeResponsibleConcept, _IncomeResponsible } from "../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectFunctionalID } from "../../admin/configuracion/functionalID/SelectFunctionalID";
import { SelectAccountantTree } from "../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { CostingCenterSelect } from "../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { IDAdquisitionProject } from "../../erp/AdquisitionProject/AdquisitionProjectSelect";
import { SelectBusinessCore } from "../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { SelectBudgetTypes } from "../../erp/cellEditor/AccountantConcept/SelectBudgetTypes";
import { SelectBudgetType } from "../../admin/configuracion/select/SelectBudgetType";
import { SelectBudgetIDType } from "../../admin/configuracion/select/SelectBudgetIDType";
import { SelectBudgetID } from "../../admin/configuracion/BudgetID/SelectBudgetID";
import { AdjustmentConstant } from "./AdjustmentConstant/AdjustmentConstant";

interface Props {
    IncomeResponsible: number;
}

export const IncomeResponsibleConcept = ({ IncomeResponsible }: Props) => {

    const income = useDataBean(_IDIncomeResponsibleConcept);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalresp, setModalresp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IncomeResponsible])

    const getLista = () => {

        income.instance.getIncomeResponsibleConceptCatalog(IncomeResponsible).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        income.setBean({
            IDIncomeResponsible: IncomeResponsible
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        income.deleteItemVoid(income.bean.IDIncomeResponsibleConcept).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        income.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDIncomeResponsibleConcept', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterCode', visible: true },
        { title: 'Línea de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Ajuste de Compensación', property: 'IsAdjustment', visible: true },
        { title: 'Tipo Ajuste', property: 'AdjustmentTypeName', visible: true },
        { title: 'Utilizar Presupuesto ?', property: 'UseBudget', visible: true },
        { title: 'Tipo de Presupuesto a Afectar', property: 'BudgetTypeName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${income.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Conceptos de Detalle de Ingresos">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={income.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={income.bean.Code} onChange={income.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={income.bean.Name} onChange={income.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Contable" onChange={(e) => { income.setBean({ ...income.bean, "AccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <CostingCenterSelect label="Centro de Costo" idSelector={income.bean.CostingCenterCode} onChange={(e) => { income.setBean({ ...income.bean, "CostingCenterCode": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <IDAdquisitionProject label="Proyecto" idSelector={income.bean.IDProject} onChange={(e) => { income.setBean({ ...income.bean, "IDProject": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBusinessCore label='Línea de Negocio' returnType="Object" idSelector={income.bean.IDBusinessCore} onChange={(e) => { income.setBean({ ...income.bean, "IDBusinessCore": e.IDBusinessCore }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Ajuste de Compensación" estado={income.bean.IsAdjustment} eventChange={(e: any) => { income.setBean({ ...income.bean, "IsAdjustment": e }) }}></BasicSwitch>
                            </div>
                            {income.bean.IsAdjustment && <>
                                <div className="col-md-6">
                                    <AdjustmentConstant idSelector={income.bean.AdjustmentType} onChange={(e) => { income.setBean({ ...income.bean, "AdjustmentType": e }) }} />
                                </div>
                            </>}
                            <div className="col-md-6">
                                <BasicSwitch label="Utilizar Presupuesto ?" estado={income.bean.UseBudget} eventChange={(e: any) => { income.setBean({ ...income.bean, "UseBudget": e }) }}></BasicSwitch>
                            </div>
                            {income.bean.UseBudget &&
                                <>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <SelectBudgetType idSelector={income.bean.IDBudgetType} onChange={(e) => { income.setBean({ ...income.bean, "IDBudgetType": e }) }} label='Tipo de Presupuesto' />
                                        </div>
                                        <div className="col-md-6">
                                            <SelectBudgetID label="Rubro Presupuestal" onChange={(e) => { income.setBean({ ...income.bean, "BudgetIDStr": e.JsonCode }) }} jsonCode={income.bean.BudgetIDStr} edit={false} />
                                            {/* <SelectAccountantTree label="Rubro Presupuestal" onChange={(e) => { income.setBean({ ...income.bean, "BudgetIDStr": e.JsonCode }) }} /> */}
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {income.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}